export default "__VITE_ASSET__DPep8ge2__"